import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=157451ff&scoped=true&"
import script from "./AppSidebar.vue?vue&type=script&lang=js&"
export * from "./AppSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=157451ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157451ff",
  null
  
)

export default component.exports